var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
import { useNavigate } from 'react-router-dom';
// dls
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg20 as SignOut } from '@swiggy-private/dls-web-icons/dist/web/generic/iosShare';
import { FullWidthButton } from '@swiggy-private/dls-web-core/dist/components/FullWidthButton';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// components
import { IconMail } from '@/constants/icons/svg';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { LOGIN_TYPE } from '@/constants/login';
import { NULL } from '@/constants/Misc';
import Routes from '@/constants/Routes';
import { localStorageKeys } from '@/constants/storage';
// style
import styles from './UserInfo.module.scss';
import { GenericAvatar } from '@/widgets/GenericAvatar';
// includes
import { initiateLogout } from '@/includes/api/auth/logout';
// helpers
import { readFromLocalStorage } from '@/helpers/storage';
const ICON_FILL_COLOR = 'rgba(0, 0, 0, 0.6)';
export default function UserInfo({ user }) {
    var _a;
    const navigate = useNavigate();
    const userEmail = (_a = user === null || user === void 0 ? void 0 : user.email) !== null && _a !== void 0 ? _a : NULL;
    const renderEmail = () => {
        return (React.createElement("div", { className: styles.textWithIcon },
            React.createElement(IconMail, { fillColor: ICON_FILL_COLOR }),
            React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Low_Emphasis }, userEmail)));
    };
    const SignOutButtonIcon = () => {
        return (React.createElement(GenericIcon, { Icon: SignOut, className: styles.signOutButtonIcon, fillColor: "primary" }));
    };
    const handleLogoutClick = () => __awaiter(this, void 0, void 0, function* () {
        yield initiateLogout();
        const loginType = yield readFromLocalStorage(localStorageKeys.LOGIN_TYPE);
        loginType === LOGIN_TYPE.EXTERNAL
            ? navigate(Routes.EXTERNAL_LOGIN)
            : navigate(Routes.EMPLOYEE_LOGIN);
    });
    return (React.createElement("div", { className: styles.modal },
        React.createElement("div", { className: styles.modalHeader },
            React.createElement(GenericAvatar, { name: userEmail, className: styles.modalHeaderAvatar }),
            React.createElement("div", { className: styles.name },
                React.createElement(Text, { variant: DlsFontVariants.header_H4, className: styles.modalHeaderName }, userEmail.split('@')[0]),
                renderEmail())),
        React.createElement("div", { className: styles.modalFooter },
            React.createElement(FullWidthButton, { variant: "secondary", onClick: handleLogoutClick, outlinedIcon: SignOutButtonIcon, className: styles.signOutButton },
                React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, "Sign Out")))));
}
